import { useGetOrdersIdHook } from '@api-product/🛍️-заказы/🛍️-заказы';
import { useQuery } from '@tanstack/react-query';

export const useOrderInfo = (id: string) => {
  const getOrder = useGetOrdersIdHook();

  const {
    data: responseData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [id],
    queryFn: () => {
      return getOrder(Number(id));
    },
    refetchInterval: 60000 * 5,
    refetchOnWindowFocus: false,
    retry: false,
    placeholderData: prev => prev,
    gcTime: 0,
  });

  const order = responseData?.data;

  return {
    order,
    isFetching: isLoading,
    refetch,
  };
};
